<template lang="pug"></template>

<script>
export default {
    name: 'BotaoDashboardOperacoes',
    componentOptions: {
        title: 'Dashboard Operações',
        actions: [
            [
                {
                    name: 'Dashboard',
                    iconClass: 'lyra-icon lyra-dashboard',
                    showView: false,
                    action: 'abrirDashboard',
                    route: 'operacaoDashboard'
                }
            ]
        ]
    },

    methods: {
        abrirDashboard() {
            if (this.$route.name !== 'operacaoDashboard') {
                this.$router.push({ name: 'operacaoDashboard' });
            } else {
                this.$router.go();
            }
        }
    }
};
</script>
